import React, {useContext, useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import "../../assets/stylesheets/choose-us.css";
import Mark from "../../assets/image/mark.svg";
import { Helmet } from "react-helmet";
import Logo from "../../assets/image/logo.svg";
import i18n from 'i18next';
import {ContactInfoContext} from "./ContactInfoContext";

function ChooseUs() {
  const { t } = useTranslation(["choose"]);
  const { contactInfo } = useContext(ContactInfoContext);

  return (
      <>
        <Helmet>
          <link rel="canonical" href={`https://sievn.am/${i18n.language}/${t("whyChooseUs")}`} />
          <meta property="og:url" content={`https://sievn.am/${i18n.language}/${t("whyChooseUs")}`} />
          <meta property="og:title" content={t("chooseTitle")} />
          <meta property="og:site_name" content="sievn.am" />
          <meta property="og:description" content={t("chooseDescribe")} />
          <meta property="og:image" content={Logo} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta name="description" content={t("chooseDescribe")} />
          <title>{t("chooseTitle")}</title>
        </Helmet>
        <div className="choose-page">
          <div className="about-start-choose">
            <img src={contactInfo.chooseUsUrl} alt="Why Choose Us" />
          </div>

          <div className="main-container-choose">
            <div className="headings-choose">
              <h1>
                <em>{t("chooseUs")}</em>
              </h1>
            </div>
            <div className="choose-section-choose">
              <ul>
                <li>
                  <img src={Mark} alt="Checkmark" />
                  {t("chooseUs1")}
                </li>
                <li>
                  <img src={Mark} alt="Checkmark" />
                  {t("chooseUs2")}
                </li>
                <li>
                  <img src={Mark} alt="Checkmark" />
                  {t("chooseUs3")}
                </li>
                <li>
                  <img src={Mark} alt="Checkmark" />
                  {t("chooseUs4")}
                </li>
              </ul>
              <div className="content-choose">
                <h3>{t("chooseNow")}</h3>
                <p className="text-gray-700">
                  📍 {t("choosenowad")} {contactInfo.address}
                </p>
                <a href={`mailto:${contactInfo.email}`}>
                  📧 {t("choosenowmail")} {contactInfo.email}
                </a>
                <a href={`mailto:${contactInfo.email2}`}>
                  📧 {contactInfo.email2}
                </a>
                <div>
                  <a href={`tel:${contactInfo.telPhone}`}>
                    📞 {t("choosenowph")} {contactInfo.telPhone}
                  </a>
                  <a href={`tel:${contactInfo.telPhone2}`}>
                    📞 {contactInfo.telPhone2}
                  </a>
                </div>
                <p>{t("chooseLast")}</p>
              </div>
            </div>
          </div>
        </div>
      </>
  );
}

export default ChooseUs;